module.exports = __webpack_public_path__ + "img/biglietto-mediapics.01c3e0eb.gif";